import React, { useState, useEffect } from "react";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Button from "../../components/button/button";
import InputTextfield from "../../components/inputs/inputTextfield/inputTextfield";
import { getApiInstance, initializeApi } from "../../utils/api";
import "./ratios.scss";

export default function Ratios() {
    const [ratios, setRatios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    // Cargar los ratios al inicio
    useEffect(() => {
        loadRatios();
    }, []);

    // Función para cargar los ratios desde el backend
    const loadRatios = async () => {
        try {
            setLoading(true);
            setError(null);
            await initializeApi();
            const api = getApiInstance();
            
            const response = await api.get('/api/PresupuestosRatiosObjetivo');
            
            // Transformar los datos del backend al formato del frontend
            const ratiosData = response.data.map(item => ({
                codigoGrupo: item.codigoGrupo,
                categoria: item.nombreGrupo,
                precioM2: item.ratioObjetivo.toString(),
                activo: item.activo
            }));
            
            setRatios(ratiosData);
        } catch (error) {
            console.error('Error al cargar ratios:', error);
            setError('Error al cargar los ratios. Por favor, intenta nuevamente.');
            
            // En caso de error, usar datos por defecto
            setRatios([
                { codigoGrupo: "MOB_GENERAL", categoria: "Mobiliario General", precioM2: "720", activo: true },
                { codigoGrupo: "MOB_ESPECIAL", categoria: "Mobiliario Especial", precioM2: "720", activo: true },
                { codigoGrupo: "REV_MOBILIARIO", categoria: "Revestimientos Mobiliario", precioM2: "720", activo: true },
                { codigoGrupo: "SUELO_TARKETT", categoria: "Suelo Tarkett", precioM2: "30", activo: true },
                { codigoGrupo: "AUDIOVISUALES", categoria: "Audiovisuales (Audio + Pantallas)", precioM2: "110", activo: true },
                { codigoGrupo: "ILUMINACION", categoria: "Iluminación", precioM2: "55", activo: true }
            ]);
        } finally {
            setLoading(false);
        }
    };



    const handleRatioChange = (codigoGrupo, field, value) => {
        setRatios(prevRatios =>
            prevRatios.map(ratio =>
                ratio.codigoGrupo === codigoGrupo ? { ...ratio, [field]: value } : ratio
            )
        );
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setError(null);
            await initializeApi();
            const api = getApiInstance();
            
            // Guardar cada ratio individualmente
            const savePromises = ratios.map(async (ratio) => {
                const requestData = {
                    codigoGrupo: ratio.codigoGrupo,
                    nombreGrupo: ratio.categoria,
                    ratioObjetivo: parseFloat(ratio.precioM2) || 0,
                    activo: ratio.activo !== false // por defecto true
                };
                
                return api.post('/api/PresupuestosRatiosObjetivo', requestData);
            });
            
            await Promise.all(savePromises);
            console.log("Ratios guardados correctamente");
            
            // Recargar los datos después de guardar
            await loadRatios();
            
        } catch (error) {
            console.error("Error al guardar ratios:", error);
            setError('Error al guardar los ratios. Por favor, intenta nuevamente.');
        } finally {
            setSaving(false);
        }
    };

    const handleReset = () => {
        loadRatios(); // Recargar desde el backend para resetear
    };

    return (
        <div className="ratios">
            <SectionHeader
                title="Cuadro de Mando de Ratios"
                subtitle="Configura los ratios de coste por categoría de mobiliario"
            />
            
            <div className="ratios__content">
                {error && (
                    <div className="ratios__error" style={{
                        background: '#ffebee',
                        border: '1px solid #f44336',
                        color: '#d32f2f',
                        padding: '12px',
                        borderRadius: '4px',
                        marginBottom: '16px'
                    }}>
                        {error}
                    </div>
                )}
                
                <div className="ratios__header">
                    <div className="ratios__header__actions">
                        <Button
                            label={saving ? "Guardando..." : "Guardar"}
                            onClick={handleSave}
                            variant="filled"
                            disabled={saving || loading}
                        />
                    </div>
                </div>

                {loading ? (
                    <div className="ratios__loading" style={{
                        textAlign: 'center',
                        padding: '40px',
                        color: '#666'
                    }}>
                        Cargando ratios...
                    </div>
                ) : (
                    <div className="ratios__table">
                        <div className="ratios__table__header">
                            <div className="ratios__table__header__category">Categoría</div>
                            <div className="ratios__table__header__precio">€/m² superficie construida</div>
                        </div>
                        
                        <div className="ratios__table__body">
                            {ratios.map((ratio) => (
                                <div key={ratio.codigoGrupo} className="ratios__table__row">
                                    <div className="ratios__table__row__category">
                                        {ratio.categoria}
                                    </div>
                                    <div className="ratios__table__row__precio">
                                        <InputTextfield
                                            placeholder=""
                                            value={ratio.precioM2}
                                            onChange={(e) => handleRatioChange(ratio.codigoGrupo, 'precioM2', e.target.value)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}